import { hexGrid } from './hex';
import { squareGrid } from './square';
import { triangleGrid } from './triangle';
import type { GridGeometry } from './types';

const grids: Record<string, GridGeometry> = { hex: hexGrid, square: squareGrid, triangle: triangleGrid };

/** Default grid for backward compatibility */
export const grid = hexGrid;

/** Resolve grid geometry by type string (defaults to hex) */
export function getGrid(type: string): GridGeometry {
  return grids[type] ?? hexGrid;
}

export type { GridGeometry } from './types';
